import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LineChartSerie, PollResult } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.type";
import { PollAvailableChoice } from "../../user-polls.type";
import { TimelinePollResultTimelineItemType } from "@teammood/timeline";
import { ClosedRecurrencePollResults, RecurrencePollResults } from "../../../create-poll/create-poll.type";
import { NgClass } from "@angular/common";

@Component({
    selector: 'poll-results-legend',
    templateUrl: './poll-results-legend.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        NgClass
    ]
})
export class PollResultsLegendComponent implements OnInit {

    protected orderedValues: PollAvailableChoice[] = [];
    protected nullSeries: number;
   
    @Input() availableChoices: PollAvailableChoice[] = []
    @Input() type: TimelinePollResultTimelineItemType;
    @Input() series?: LineChartSerie[];
    @Input() trendAllResults?: ClosedRecurrencePollResults | RecurrencePollResults;

    constructor() { }

    ngOnInit(): void {
        if (this.type !== 'closedQuestionResultItem') {
            this.nullSeries = this.series ? this.series[0].data.filter(value => value === null).length : undefined;
            this.orderedValues = this.availableChoices.sort((a, b) => b.position - a.position);
        }
    }
    
}